// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__74YrX","col":"Table_col__3ftmU","fulfillmentStatus":"Table_fulfillmentStatus__1p74P","emailCol":"Table_emailCol__2rH-D"};